module.exports = __webpack_public_path__ + "static/media/dataofdata.881afa27.jpg";